module.exports = __webpack_public_path__ + "static/media/plus.6d6d32f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/entityList/plus.svg
// module id = 1988
// module chunks = 0